<template>
    <div class="innerService">
        <loading v-if="loading"></loading>
        <Form v-else
              ref="configForm"
              label-position="left"
              :model="configForm"
              :label-colon="configs.colon"
              :label-width="configs.labelPositon === 'top' ? null : configs.labelWidth < 160 ? 160 : configs.labelWidth">
            <template v-for="(item, index) in configForm.dataList">
                <div class="item-div"
                     :class="{'norequired-mark': !item.rules.required}"
                     v-if="dynamicVisible(item.rules.dynamicVisibleValue)"
                     :key="index">
                    <!-- 分割线 -->
                    <Divider :style="{margin: '35px 0'}"
                             v-if="item.type === 'line' && !item.options.isParentNode"
                             :dashed="item.options.dashed" />
                    <div v-else-if="item.type === 'line' && item.options.isParentNode"
                         class="group-title mar-bot15">
                        <span :style="{display:'inline-block',width: (configs.labelWidth < 160 ? 160 : configs.labelWidth) - 12+'px',textAlign:'left'}"> {{$t(item.options.label)}}</span>
                    </div>
                    <!-- modelArts表格 -->
                    <div v-else-if="item.type === 'table'"
                         style="padding-left: 160px;">
                        <modelArtsTable v-if="priceData"
                                        :priceData="priceData"
                                        :templateType="item.options.templateType"></modelArtsTable>
                    </div>
                    <FormItem v-else
                              :style="item.options.tooltip||(['SFS2.0','HPC', 'HPC-SAAS'].includes(templateType)&&item.options.attrKey=='capacity')?'margin-bottom:18px;':''"
                              :class="{strong: item.options.isParentNode, obs:item.options.attrKey === 'obsTips' }"
                              :prop="`dataList.${index}.options.defaultValue`"
                              :rules="getRules(item)"
                              :label="$t(item.options.label)">
                        <!-- 段落 -->
                        <p v-if="item.type === 'content'"
                           :key="item.options.defaultValue">{{$t(item.options.defaultValue)}}</p>
                        <span style="color: #ed4014;"
                              v-if="item.rules.required && !item.options.label"> * </span>
                        <Input @on-change="dynamicChange(item, $event)"
                               v-if="item.type === 'input'&&!(['HPC', 'HPC-SAAS'].includes(templateType)&&item.options.attrKey=='size')  && (item.options.modal !== 'password')"
                               v-model="item.options.defaultValue"
                               :disabled="item.options.disabled"
                               :placeholder="$t(item.options.placeholder)"
                               :style="{ width: item.options.width }"
                               :maxlength="item.options.maxLength" />
                        <Input @on-change="dynamicChange(item, $event)"
                               v-if="item.type === 'input' && (item.options.modal === 'password')"
                               v-model="item.options.defaultValue"
                               type="password"
                               password
                               :disabled="item.options.disabled"
                               :placeholder="$t(item.options.placeholder)"
                               :style="{ width: item.options.width }"
                               :maxlength="item.options.maxLength" />
                        <Input @on-change="dynamicChange(item, $event)"
                               v-if="item.type === 'textarea' "
                               type="textarea"
                               show-word-limit
                               :autosize="{ minRows: 5  }"
                               v-model="item.options.defaultValue"
                               :placeholder="$t(item.options.placeholder)"
                               :disabled="item.options.disabled"
                               :style="{ width: item.options.width }"
                               :maxlength="item.options.maxLength" />
                        <InputNumber @on-change="dynamicChange(item, $event)"
                                     v-if="item.type === 'inputNumber'"
                                     v-model.number="item.options.defaultValue"
                                     :precision="0"
                                     :style="{ width: item.options.width }"
                                     :max="(['SFS2.0','HPC', 'HPC-SAAS'].includes(templateType)&&['capacity'].includes(item.options.attrKey))?Number(maxTimesStorage):item.options.max"
                                     :min="(['HPC','SFS2.0', 'HPC-SAAS'].includes(templateType)&&['capacity'].includes(item.options.attrKey))?Number(minTimesStorage):item.options.min"
                                     :disabled="item.options.disabled"
                                     :placeholder="$t(item.options.placeholder)"
                                     :step="item.options.step"
                                     :active-change="false"
                                     controls-outside></InputNumber>
                        <!--HPC共享资源池默认存储大小-->
                        <span v-if="(['HPC', 'HPC-SAAS'].includes(templateType)&&item.options.attrKey=='size')">{{sfsDefaultStorage}}</span>
                        <!--加单位GB-->
                        {{(['SFS2.0'].includes(templateType)&&item.options.attrKey=='capacity')||(['HPC', 'HPC-SAAS'].includes(templateType)&&['size','capacity'].includes(item.options.attrKey))?'GB':''}}
                        <!-- 专属资源池 数量换算算力 -->
                        <span v-if="(['DRP'].includes(templateType)&&item.options.attrKey=='count')"
                              style="padding-left:10px;">{{pflopsText}}</span>

                        <Slider @on-change="dynamicChange(item, $event)"
                                v-if="item.type === 'slider'"
                                v-model="item.options.defaultValue"
                                :style="{ width: item.options.width || '350px' ,display:'inline-block'}"></Slider>
                        <!-- 注意！！开启和关闭是值，不需要国际化 -->
                        <i-switch v-if="item.type === 'switch'"
                                  true-value="开启"
                                  false-value="关闭"
                                  v-model="item.options.defaultValue"
                                  @on-change="dynamicChange(item, $event)">
                        </i-switch>
                        <TimePicker v-if="item.type === 'time'"
                                    v-model="item.options.defaultValue"
                                    :type="item.options.modal"
                                    :placeholder="$t(item.options.placeholder)"
                                    :style="{ width: item.options.width }"></TimePicker>
                        <DatePicker v-if="item.type === 'date'"
                                    :type="item.options.modal"
                                    :transfer="true"
                                    v-model="item.options.defaultValue"
                                    :style="{ width: item.options.width }"
                                    :placeholder="$t(item.options.placeholder)"></DatePicker>
                        <Upload v-if="item.type === 'upload'"
                                :action="item.options.url"
                                :multiple="item.options.multiple">
                            <Button icon="ios-cloud-upload-outline">{{$t('附件上传')}}</Button>
                        </Upload>
                        <Select @on-change="dynamicChange(item, $event)"
                                v-if="item.type === 'select'"
                                :transfer="true"
                                :multiple="item.options.multiple"
                                v-model="item.options.defaultValue"
                                :disabled="item.options.disabled"
                                :style="{ width: item.options.width }">
                            <Option v-for="el in item.options.defaultData"
                                    :value="el.value"
                                    :key="el.value">{{ el.label }}</Option>
                        </Select>
                        <RadioGroup @on-change="dynamicChange(item, $event)"
                                    v-if="item.type === 'radio'"
                                    :type="item.options.modal === 'default' ? null : item.options.modal"
                                    v-model="item.options.defaultValue">
                            <Radio v-for="(subitem, index) in item.options.defaultData"
                                   :key="index"
                                   :label="subitem.value">{{$t(subitem.label)}}</Radio>
                        </RadioGroup>
                        <!-- <span v-if="['ModelArts'].includes(templateType)">{{$t(' *  表示时长为固定定价，产品退订时，不进行退费处理')}}</span> -->
                        <CheckboxGroup @on-change="dynamicChange(item, $event)"
                                       v-if="item.type === 'checkbox'"
                                       style="display:inline-block;"
                                       v-model="item.options.defaultValue">
                            <Checkbox v-for="(subitem, index) in item.options.defaultData"
                                      :key="index"
                                      :label="subitem.value">{{subitem.label}}</Checkbox>
                        </CheckboxGroup>
                        <Tree v-if="item.type === 'tree'"
                              :data="item.options.defaultData"
                              @on-check-change="getTree"
                              show-checkbox></Tree>
                        <!-- 业务组件 -->
                        <!-- 计算规格 -->
                        <div v-if="item.type === 'calculation'"
                             style='display:inline-block;'>
                            <label v-for="(subItem, index) in item.options.defaultData"
                                   :class="{'active':chooseCalculationIndex === index}"
                                   class="calculation-item"
                                   :key="index">
                                <input name="calculation"
                                       type="radio"
                                       :value="item.options.value"
                                       @input="chooseCalculation(item,subItem, index)" />
                                <p>{{subItem.type}}</p>
                                <p>{{subItem.specifications}}</p>
                            </label>
                        </div>
                        <!-- 文件系统 -->
                        <template v-if="item.type === 'storageInfo'">
                            <Select @on-change="dynamicChange(item, $event)"
                                    :transfer="true"
                                    :multiple="item.options.multiple"
                                    v-model="item.options.defaultValue"
                                    :style="{ width: item.options.width }">
                                <Option v-for="el in item.options.defaultData"
                                        :value="el.value"
                                        :key="el.value">{{ el.label }}</Option>
                            </Select>
                            <Tooltip class="mar-right15"
                                     :content="$t('刷新')"
                                     theme="light"
                                     placement="top"
                                     :transfer="true">
                                <span @click="refreshStorageInfo(item)"
                                      class="icon-refresh-o-2 refresh-icon mar-left10"
                                      style="display:inline-block"></span>
                            </Tooltip>
                            <a><span @click="toCreate"><i class='icon-add'></i> {{$t('创建文件系统')}}</span> </a>
                        </template>
                        <!-- 集群套餐 -->
                        <template v-if="item.type === 'clusterPackage'">
                            <clusterPackageTable :options="item.options"
                                                 :index="index"
                                                 @checkItem="oncheckItem"></clusterPackageTable>
                        </template>
                        <!-- 文件系统table -->
                        <template v-if="item.type === 'storageInfoTable'">
                            <storageInfoTable :data="storageInfoData"></storageInfoTable>
                        </template>
                        <!-- tooltip -->
                        <Tooltip v-if="item.options.tooltip"
                                 theme="light"
                                 placement="right"
                                 style="margin-left:6px;vertical-align: top;"
                                 :transfer="true">
                            <i class="icon-explanation-1-o icon-active"
                               style="color:#2d8cf0;vertical-align: middle;"></i>
                            <div slot="content">
                                <p style="white-space: pre-wrap;">{{ $t(item.options.tooltip) }}</p>
                            </div>
                        </Tooltip>
                        <!-- <div class="instruction"
                             v-if="item.options.tooltip">
                            <p>{{$t(item.options.tooltip)}}</p>
                        </div> -->
                        <!--弹性文件服务容量加提示/HPC共享资源池专属文件存储大小加提示-->
                        <!-- <Tooltip v-if="['SFS2.0','HPC'].includes(templateType)&&item.options.attrKey=='capacity'"
                             theme="light"
                             placement="right"
                             style="margin-left:6px;vertical-align: middle;"
                             :transfer="true">
                        <i class="icon-prompt-1-o tips-icon-prompt"
                           style="color:#2d8cf0"></i>
                        <div slot="content">
                            <p>{{$t('默认根据申请容量进行小时计费')}}；</p>
                            <p>{{$t('如果超出存储容量则按实际使用空间计费')}}；</p>
                            <p>{{$t('容量大于等于')}}{{minTimesStorage}}{{$t('小于等于')}}{{maxTimesStorage}}</p>
                        </div>
                    </Tooltip> -->
                        <div class="instruction"
                             v-if="['SFS2.0','HPC', 'HPC-SAAS'].includes(templateType)&&item.options.attrKey=='capacity'">
                            <p v-if="['HPC', 'HPC-SAAS'].includes(templateType)"><span v-if="['HPC', 'HPC-SAAS'].includes(templateType)">{{$t('额外增加的专属文件存储')}}，</span>{{$t('默认按照实际申请容量每小时计费')}}，{{$t('如果超过存储容量则按照实际使用量计费')}}。</p>
                            <p v-show="noErrorIng">{{['HPC', 'HPC-SAAS'].includes(templateType)?$t('存储'):$t('容量')}}{{$t('不能小于')}}{{minTimesStorage}}{{$t('大于')}}{{maxTimesStorage}}</p>
                        </div>
                    </FormItem>
                </div>
            </template>
        </Form>
    </div>
</template>
<script>
import loading from '@/views/components/basic/loading'
import modelArtsTable from '@/views/portal/application/components/inner/model-arts-table.vue'
import innerServiceMixin from '@/mixin/innerServiceMixin.js'
import API from '@/service/api.js'
import clusterPackageTable from '@/views/portal/application/components/inner/clusterPackage-table.vue'
import storageInfoTable from '@/views/portal/application/components/inner/storage-info-table.vue'
import {
    isNullOrEmpty
} from '@/service/utils'
export default {
    name: 'preview',
    components: {
        modelArtsTable,
        loading,
        clusterPackageTable,
        storageInfoTable
    },
    props: {
        panelDataList: {
            type: Array,
            default: () => {
                return []
            }
        },
        configs: {
            type: Object,
            default: () => {
                return {}
            }
        },
        templateType: {
            type: String,
            default: ''
        },
        selectedEnvSid: {
            type: Number,
            default: 0
        },
        priceData: {
            type: Array,
            default: () => {
                return []
            }
        }
    },
    mounted () { },
    mixins: [innerServiceMixin],
    data () {
        return {
            loading: false,
            maxTimesStorage: 0,
            minTimesStorage: 0,
            sfsDefaultStorage: 0,
            value1: '',
            current: null,
            customData: null,
            ruleInline: {},
            panelDataMap: {}, // 存储item.options.attrKey 和 item 的映射关系
            chooseCalculationIndex: -1,
            returnForm: {},
            configForm: {
                dataList: []
            },
            storageInfoData: [],
            pflopsText: '',
            noErrorIng: true
        }
    },
    created () {
        const initData = JSON.parse(JSON.stringify(this.panelDataList))
        this.initData(initData)
        this.getConfig()
    },
    methods: {
        getData (url) {
            return this.axios.get(this.$store.state.app.url.RestUrl + url)
        },
        checkName (name, val) {
            // 查询重复次数  验证是否重复加type
            const url = val ? `${API.GET_SHARE_COUNT}?name=${name}&type=repeat` : `${API.GET_SHARE_COUNT}?name=${name}`
            return this.axios.get(this.urlFormat(url, false)).then(res => {
                return res
            })
        },
        // 名称自动+1，全局不重复
        async resName (val) {
            const count = await this.checkName(val)
            return val + '_' + (count + 1)
        },
        async initData (initData) {
            if (initData) {
                // 初始化默认值
                for (const item of initData) {
                    // 动态数据
                    if (item.options.customData) {
                        await this.handleItems(item, true)
                    } else if (['inputNumber', 'slider'].includes(item.type)) {
                        item.options.defaultValue = +item.options.defaultValue
                    }
                    this.panelDataMap[item.options.attrKey] = item
                    // this.formatDefaultValue(item)
                }
                // 给HPC共享资源池专属文件存储的存储大小设置最小值
                if (['HPC', 'SFS2.0', 'HPC-SAAS'].includes(this.templateType) && this.panelDataMap.capacity) {
                    this.panelDataMap.capacity.options.defaultValue = String(this.minTimesStorage)
                }
                if (['SFS2.0'].includes(this.templateType) && this.panelDataMap.name) {
                    this.panelDataMap.name.options.defaultValue = await this.resName(this.$store.state.user.currentUser.info.account)
                }
                // this.dataList = Object.values(this.panelDataMap)
                // 兼容老版本的显示和隐藏
                this.configForm.dataList = Object.values(this.panelDataMap)
                this.inquiry(true)
            }
        },
        async handleItems (item, firstTime) {
            if (item.options.customData) {
                firstTime && (this.loading = true)
                const rootKeyList = [] // 存放id
                const axiosList = [] // 存放请求
                for (const ajaxItem of item.options.customUrl) {
                    rootKeyList.push(ajaxItem.id)
                    axiosList.push(this.getData(ajaxItem.url))
                }
                const resultList = await Promise.all(axiosList)
                /* options中非数据列的项 */
                for (const optionsItem in item.options) {
                    const value = item.options[optionsItem]
                    if (!['nodeName'].includes(optionsItem) && typeof value === 'string') {
                        item.options[optionsItem] = this._isDynamicString(value) ? this._dynamicFun(value, resultList, null, rootKeyList) : value
                    }
                    // 触发条件中的动态数据也要处理
                    if (optionsItem === 'dispatchsList' && value.length) {
                        value.forEach(valueItem => {
                            valueItem.defaultValue = this._isDynamicString(valueItem.defaultValue) ? this._dynamicFun(valueItem.defaultValue, resultList, null, rootKeyList) : valueItem.defaultValue
                        })
                    }
                }
                /* options中数据项,要有options.defaultData才去解析 */
                if (item.options.defaultData) {
                    if (item.options.isArray) {
                        /* 获取数据节点 */
                        if (this._isDynamicString(item.options.nodeName)) {
                            const nodeData = this._dynamicFun(item.options.nodeName, resultList, null, rootKeyList)
                            item.options.defaultData = []
                            const dynamicConfig = item.options.dynamicConfig
                            const { label, value } = dynamicConfig
                            !isNullOrEmpty(nodeData) && nodeData.forEach(element => {
                                item.options.defaultData.push({
                                    label: this._isDynamicString(label) ? this._dynamicFun(label, element, null, 'item') : label,
                                    value: this._isDynamicString(value) ? this._dynamicFun(value, element, null, 'item') : value
                                })
                            })
                        }
                    } else {
                        const defaultData = item.options.defaultData
                        item.options.defaultData = []
                        item.options.defaultData = defaultData.map(element => {
                            return {
                                label: this._isDynamicString(element.label) ? this._dynamicFun(element.label, resultList, null, rootKeyList) : element.label,
                                value: this._isDynamicString(element.value) ? this._dynamicFun(element.value, resultList, null, rootKeyList) : element.value
                            }
                        })
                    }
                }
                this.loading = false
            }
        },
        getConfig () {
            this.axios.get(this.urlFormat(API.PUT_ALL_CONFIG + '?configTypes=other_config&configTypes=hpc_config&configTypes=sfs_config', true)).then(res => {
                res.forEach(element => {
                    if (['HPC', 'SFS2.0', 'HPC-SAAS'].includes(this.templateType) && element.configKey === 'hpc.sfs.base.config') {
                        let list = JSON.parse(element.configValue) || []
                        if (['HPC'].includes(this.templateType)) {
                            list = list.find(item => item.serviceType === 'SFS')
                            this.minTimesStorage = list.privateMinCapacity
                            this.maxTimesStorage = list.privateMaxCapacity
                            this.sfsDefaultStorage = list.defaultShareCapacity
                        } else {
                            list = list.find(item => item.serviceType === 'SFS2.0')
                            this.minTimesStorage = list.privateMinCapacity
                            this.maxTimesStorage = list.privateMaxCapacity
                            this.sfsDefaultStorage = list.defaultShareCapacity
                        }
                        // 给HPC共享资源池专属文件存储的存储大小设置最小值
                        if (this.panelDataMap.capacity) {
                            this.panelDataMap.capacity.options.defaultValue = String(this.minTimesStorage)
                        }
                    }
                    // if (['SFS2.0'].includes(this.templateType) && element.configKey === 'hpc.sfs.max.times.storage') {
                    //     this.minTimesStorage = '50'
                    //     this.maxTimesStorage = element.configValue
                    // }
                    // if (element.configKey === 'hpc.sfs.default.share.storage') {
                    //     this.sfsDefaultStorage = element.configValue
                    // }
                })
            })
        },
        refreshStorageInfo (item) {
            const url = item.options.customUrl[0] && item.options.customUrl[0].url
            if (!url) return
            this.handleItems(item)
        },
        async toCreate () {
            const product = await this.axios.get(this.urlFormat(API.GET_PRODUCTS, false))
            const sfsId = product.dataList.find(item => item.showType === 'SFS2.0').id
            const { href } = this.$router.resolve({
                path: '/apply/share/' + sfsId
            })
            window.open(href, '_blank')
        },
        getValid (pattern, message) {
            return (rule, value, callback) => {
                const exp = new RegExp(pattern)
                if (!exp.test(value)) {
                    callback(new Error(this.$t(message)))
                } else {
                    callback()
                }
            }
        },
        dynamicChange (currentData, e) {
            console.log(e, 'e', currentData)
            // 根据触发的条件，把dataList相应的item替换掉，以达到目的
            // if (!currentData.options.dispatchsList) return
            if (currentData.options.dispatchsList) {
                for (const dispatchItem of currentData.options.dispatchsList) {
                    const result = this.conditionResult(dispatchItem, e)
                    if (result) {
                        this.replaceData(dispatchItem)
                    }
                }
            }
            // AI专属资源池 开发环境/训练  需要传businessType = 'AI全流程开发'
            if (currentData.options.attrKey === 'calculation' || currentData.options.attrKey === 'calculation2') {
                this.returnForm.businessType = 'AI全流程开发'
            }
            // 限流，防止询价过快
            if (!this.inquiryFlag) {
                this.inquiryFlag = setTimeout(() => {
                    this.inquiryFlag = null
                    this.inquiry(currentData.options.attrKey)
                }, 500)
            }
        },
        conditionResult (dispatchItem, value) {
            const { event, defaultValue } = dispatchItem
            let result = false
            switch (event) {
                case 'equal': {
                    result = Array.isArray(value) ? value.includes(defaultValue) : (value === defaultValue)
                    break
                }
                case 'lgt':
                    result = value > defaultValue
                    break
                case 'lst':
                    result = value < defaultValue
                    break
                case 'notEqual': {
                    result = Array.isArray(value) ? !value.includes(defaultValue) : (value !== defaultValue)
                    break
                }
                default:
                    result = false
                    break
            }
            return result
        },
        replaceData (dispatchItem) {
            const copyData = JSON.parse(JSON.stringify(this.panelDataMap))
            for (const contentItem of dispatchItem.content) {
                // 将动态数据进行转换
                this.handleItems(contentItem)
                // 遍历，替换
                copyData[contentItem.options.attrKey] = contentItem
                // 动态绑定
                // this.formatDefaultValue(contentItem)
            }
            // this.dataList = Object.values(copyData)
            this.configForm.dataList = Object.values(copyData)
        },
        formatDefaultValue (data) {
            if (!['line', 'content', 'table'].includes(data.type)) {
                let defaultValue = data.options.defaultValue
                if (['inputNumber', 'slider'].includes(data.type)) {
                    defaultValue = +defaultValue
                }
                if (!defaultValue && !['SFS2.0'].includes(this.templateType)) {
                    if (['select'].includes(data.type)) {
                        const defaultData = data.options.defaultData || []
                        defaultValue = defaultData.length > 0 ? defaultData[0].value : null
                    }
                }
                // HPC共享资源池默认存储大小
                if (['input'].includes(data.type) && data.options.attrKey === 'size' && ['HPC', 'HPC-SAAS'].includes(this.templateType)) {
                    defaultValue = +this.sfsDefaultStorage
                }
                // if (['DRP', 'IAAS', 'AI'].includes(this.templateType) && data.options.attrKey === 'calculation2') {
                //     // AI共享资源池兼容  calculation2   calculation   传值都为calculation
                //     data.options.attrKey = 'calculation'
                // }
                this.returnForm[data.options.attrKey] = defaultValue
            }
        },
        getFormData () {
            this.configForm.dataList.forEach(item => {
                this.formatDefaultValue(item)
            })
            const result = {}
            result.chargeData = {
                value: this.returnForm.chargeType,
                name: this.returnForm.chargeType === 'PrePaid' ? this.$t('包年包月') : (this.returnForm.chargeType === 'PostPaid' ? this.$t('按量付费') : this.$t('不计费'))
            }
            return { ...this.returnForm, ...result }
        },
        chooseCalculation (item, subItem, index) {
            this.returnForm[item.options.attrKey] = subItem.value
            item.options.defaultValue = subItem.value
            this.chooseCalculationIndex = index
            this.returnForm.businessType = subItem.type
            this.inquiry(item.options.attrKey)
        },
        inquiry (attrKey) {
            // 询价
            if (['OBS', 'DRP', 'IAAS', 'SFS2.0', 'HPC', 'HPC-SAAS'].includes(this.templateType)) {
                if (['fileStorageType', 'size', 'capacity', 'category', 'shareType', 'shareProto', 'shareProto1', 'supportClusterType', 'time', 'count', 'chargeType', 'calculation', 'calculation2', 'applyType', true].includes(attrKey)) {
                    if (attrKey === 'shareType') {
                        this.configForm.dataList.forEach((item, index) => {
                            if (['shareProto', 'shareProto1'].includes(item.options.attrKey)) {
                                item.options.defaultValue = ''
                            }
                        })
                    }
                    const inquiyData = this.getFormData(attrKey)
                    if (!inquiyData.envId) {
                        inquiyData.envId = this.selectedEnvSid
                    }
                    // HPC共享资源池默认存储大小
                    if (['HPC'].includes(this.templateType)) {
                        inquiyData.size = this.sfsDefaultStorage
                    }
                    let specificationsName = ''
                    if (inquiyData.applyType === 'depTrain') {
                        // 类型为开发环境/训练
                        inquiyData.calculation = this.returnForm.calculation2
                        try {
                            const calculation = this.configForm.dataList.find(item => item.options.attrKey === 'calculation2')
                            const calculationItem = calculation.options.defaultData.find(item => item.value === inquiyData.calculation)
                            specificationsName = (calculationItem && calculationItem.label) || ''
                        } catch (e) {
                            //
                        }
                    } else {
                        // 部署上线
                        inquiyData.calculation = this.returnForm.calculation
                        try {
                            const calculation = this.configForm.dataList.find(item => item.options.attrKey === 'calculation')
                            const calculationItem = calculation.options.defaultData.find(item => item.value === inquiyData.calculation)
                            specificationsName = (calculationItem && calculationItem.specifications) || ''
                        } catch (e) {
                            //
                        }
                    }
                    try {
                        let pflops = specificationsName.match(/\d+(\.\d+)?PFLOPS/)
                        pflops = pflops && pflops[0].match(/\d+(\.\d+)?/)
                        pflops = pflops && pflops[0]
                        this.pflopsText = (pflops && inquiyData.count && (Number(pflops) * inquiyData.count).toFixed(2) + ' PFLOPS') || ''
                        if (this.pflopsText) {
                            inquiyData.computingPower = Number(pflops) * inquiyData.count
                        }
                    } catch (e) {
                        //
                    }
                    this.$emit('inquiry', inquiyData, 'zero')
                }
            } else if (['HPC-DRP'].includes(this.templateType)) {
                const queryPriceKeyList = [true, 'nodeNum', 'scenario', 'time', 'flavorRef', 'chargeType', 'vncNode']
                let searchKey = attrKey
                if (typeof searchKey === 'string' && searchKey.indexOf('-') > -1) searchKey = searchKey.split('-')[0]
                if (!queryPriceKeyList.includes(searchKey)) {
                    return
                }
                const inquiyData = this.getFormData(attrKey)
                if (!inquiyData.envId) {
                    inquiyData.envId = this.selectedEnvSid
                }
                inquiyData.configList = this.getNewFormData()
                this.$emit('inquiry', inquiyData, 'zero')
            }
        },
        async getnodecallback () {
            const params = {}
            this.configForm.dataList.forEach(item => {
                const { attrKey, groupKey = '', defaultValue } = item.options
                if (attrKey.indexOf('shareType') >= 0 && !groupKey) {
                    params.shareType = defaultValue
                }
                if (groupKey && groupKey.indexOf('computeNodeInfo') >= 0) {
                    if (attrKey.indexOf('flavorRef') >= 0) {
                        params.flavorRef = defaultValue
                    }

                    if (attrKey.indexOf('resourceType') >= 0) {
                        params.resourceType = defaultValue
                    }
                }
            })
            if (['HPC-DRP'].includes(this.templateType)) {
                params.cloudEnvId = this.selectedEnvSid
            }
            let obj = {
            }
            obj = await this.axios.get(this.urlFormat(API.NODENUM_LIMIT), {
                params
            }).then(({ freeCount, sum, usedCount }) => {
                // obj.freeCount = freeCount  差值  sum-usedCount
                // obj.sum = sum // 暂时未用
                // obj.usedCount = usedCount // 暂时未用
                return {
                    freeCount: freeCount || 0,
                    sum: sum || 0,
                    usedCount: usedCount || 0
                }
            })
            return obj
        },
        getRules (item) {
            const ruleList = []
            if (item.type === 'checkbox') {
                ruleList.push({
                    required: item.rules.required || this.configs.requiredMark,
                    message: item.options.attrKey.indexOf('agreeVpc') >= 0 ? '由于业务需要，专属资源需要与平台建立对等连接配置，请允许。' : '必填项不能为空',
                    trigger: item.rules.trigger || 'blur',
                    type: 'array',
                    min: 1
                })
            } else if (item.options.attrKey.indexOf('nodeNum') >= 0 && item.options.groupKey && item.options.groupKey.indexOf('computeNodeInfo') >= 0) {
                ruleList.push({
                    required: item.rules.required || this.configs.requiredMark,
                    message: '必填项不能为空',
                    type: 'number',
                    trigger: 'blur'
                })
                // 获取最大限制值
                ruleList.push({
                    validator: async (rule, value, callback) => {
                        const obj = await this.getnodecallback()
                        if (value) {
                            if (obj.freeCount <= 0) {
                                callback(new Error(this.$t('可申请节点数目最大为' + obj.freeCount + ' 资源不足请联系管理员')))
                            } else if (obj.freeCount < value) {
                                callback(new Error(this.$t('可申请节点数目最大为' + obj.freeCount)))
                            } else {
                                callback()
                            }
                        } else {
                            callback(new Error(this.$t('节点数目不能为0')))
                        }
                        callback()
                    },
                    trigger: 'blur'
                })
            } else if (item.type === 'inputNumber') {
                ruleList.push({
                    required: item.rules.required || this.configs.requiredMark,
                    message: '必填项不能为空',
                    type: 'number',
                    trigger: 'blur'
                })
            } else if ((item.type === 'storageInfo') || (item.type === 'select' && item.options.multiple)) {
                if (item.options.multiple) {
                    ruleList.push({
                        required: item.rules.required || this.configs.requiredMark,
                        type: 'array',
                        message: '必填项不能为空',
                        trigger: item.rules.trigger || 'change'
                    })
                } else {
                    ruleList.push({
                        required: item.rules.required || this.configs.requiredMark,
                        message: '必填项不能为空',
                        type: 'number',
                        trigger: item.rules.trigger || 'change'
                    })
                }
            } else if (item.type === 'clusterPackage') {
                ruleList.push({
                    required: item.rules.required || this.configs.requiredMark,
                    message: '必填项不能为空',
                    type: 'object',
                    trigger: item.rules.trigger || 'change'
                })
            } else if (item.type === 'storageInfoTable') {
                ruleList.push({
                    required: item.rules.required || this.configs.requiredMark,
                    message: '必填项不能为空',
                    type: 'array',
                    trigger: item.rules.trigger || 'change'
                })
            } else if (item.type !== 'slider') {
                ruleList.push({
                    required: item.rules.required || this.configs.requiredMark,
                    message: '必填项不能为空',
                    trigger: item.rules.trigger || 'blur'
                })
            }
            if (['SFS2.0', 'HPC', 'HPC-SAAS'].includes(this.templateType) && item.options.attrKey === 'capacity') {
                ruleList.push(
                    {
                        validator: (rule, value, callback) => {
                            if (value < Number(this.minTimesStorage)) {
                                this.noErrorIng = false
                                callback(new Error(this.$t('不能小于') + this.minTimesStorage + 'GB'))
                                return
                            } if (value > Number(this.maxTimesStorage)) {
                                this.noErrorIng = false
                                callback(new Error(this.$t('不能大于') + this.maxTimesStorage + 'GB'))
                            } else {
                                this.noErrorIng = true
                                callback()
                            }
                        },
                        trigger: 'blur'
                    })
            }
            if (item.rules.pattern) {
                ruleList.push({
                    validator: this.getValid(item.rules.pattern, item.rules.message),
                    trigger: item.rules.trigger || 'blur'
                })
            }
            // 自定义输入 名称重复校验
            if (item.rules.required && item.options.attrKey === 'name') {
                ruleList.push(
                    {
                        validator: async (rule, value, callback) => {
                            if (value) {
                                const count = await this.checkName(value, true) // 0-不重复
                                if (count) {
                                    callback(new Error(this.$t('名称重复，请重新输入！')))
                                } else {
                                    callback()
                                }
                            } else {
                                callback()
                            }
                        },
                        trigger: 'blur'
                    })
            }
            return ruleList
        },
        string_to_dataString (str) {
            const reg = /\${(.+?)}/
            return str.match(reg)[1]
        },
        _isDynamicString (str) {
            const reg = /^\${(.+?)}$/
            return reg.test(str)
        },
        dynamicVisible (value) {
            if (!value) {
                return true
            }
            if (value === 'fasle') {
                return false
            }
            const formData = this.getFormData()
            // 打开了开关 这里获取函数内容
            const result = this._dynamicFun(value, formData, 'show', '$')
            return result
        },
        /*
* 用于生成显示条件的执行函数
* @params {String} script 执行代码
* @params {Object} model 数据源
* @params {String} target 判断是动态显示还是动态获取数据
* @params {String} argsName 函数形参的名字
*/
        _dynamicFun (script, model, target, argsName) {
            if (!script) return false
            if (this.preventAction(script)) {
                throw new Error('不能进行该操作：' + script)
            } else {
                /* 如果script中含有${}, 就获取中间的字符串 */
                if (this._isDynamicString(script)) {
                    script = this.string_to_dataString(script)
                }
                const func = script.indexOf('return') >= 0 ? `{${script}}` : ` return (${script})`
                const args = Array.isArray(argsName) ? argsName : [argsName]
                const copyModel = Array.isArray(model) ? model : [model]
                // eslint-disable-next-line no-new-func
                const Fn = new Function(...args, func)
                let result = null
                try {
                    result = Fn(...copyModel)
                    if (result === 'undefined') {
                        throw new Error()
                    } else {
                        return result
                    }
                } catch {
                    throw new Error(`${script}获取失败，值为${result}, 请检查数据和对应模板配置!`)
                }
            }
        },
        preventAction (script) {
            let result = false
            if (script.indexOf('=') > 0 && script.indexOf('==') < 0 && script.indexOf('===') < 0) {
                result = true
            }
            if (script.indexOf('delete') > 0) {
                result = true
            }
            return result
        },
        cancel () {
            this.current = null
            // this.dataList = null
            this.customData = null
            this.ruleInline = {}
            this.configForm = {
                dataList: []
            }
            this.panelDataMap = {}
            this.panelDataMap = {}
            this.chooseCalculationIndex = -1
            this.modal = false
        },
        save () {
            this.$refs.configForm.validate((res) => {
                if (res) {
                    this.$Message.success(this.$t('验证成功'))
                }
            })
        },
        arrayToTree (data) {
            const res = {}
            const map = {}
            const getHasOwnProperty = (obj, property) => Object.prototype.hasOwnProperty.call(obj, property)
            for (const item of data) {
                map[item.options.attrKey] = {
                    ...item,
                    children: getHasOwnProperty(map, item.options.attrKey) ? map[item.options.attrKey].children : []
                }
                const newItem = map[item.options.attrKey]
                if ((item.options.groupKey === 0 && !res[item.options.attrKey]) || !item.options.groupKey) {
                    res[item.options.attrKey] = newItem
                } else {
                    if (!getHasOwnProperty(map, item.options.groupKey)) {
                        map[item.options.groupKey] = {
                            children: []
                        }
                    }
                    map[item.options.groupKey].children.push(newItem)
                }
            }
            const result = Object.values(res)
            return result
        },
        getTreeData () {
            const rootList = [] // 添加对象跟节点
            this.configForm.dataList.forEach((item, index) => {
                if (item.options.isParentNode) {
                    rootList.push({
                        options: {
                            label: item.options.groupKeyLabel,
                            groupKey: 0,
                            groupType: item.options.groupType,
                            attrKey: item.options.groupKey
                        }
                    })
                }
            })
            return this.arrayToTree([...rootList, ...this.configForm.dataList])
        },
        getValueText (value, list) {
            if (!list) {
                return value
            }
            const currentItem = list.find(item => (value === item.value) || (+value === +item.value))
            return currentItem ? currentItem.label : value
        },
        formatNewData (treeData) {
            const newData = JSON.parse(JSON.stringify(treeData))
            const result = newData.map(item => {
                const newItem = {}
                if (item.children.length) {
                    newItem.value = []
                    newItem.chidrenDesc = []
                    item.children.forEach(element => {
                        const chidrenDesc = []
                        if (element.options.isParentNode) {
                            const data = element.children
                            element = {}
                            data.forEach((elementItem) => {
                                const key = elementItem.options.attrKey.split('-')[0]
                                element[key] = elementItem.options.defaultValue
                                chidrenDesc.push({
                                    label: elementItem.options.label,
                                    value: this.getValueText(elementItem.options.defaultValue, elementItem.options.defaultData),
                                    isShow: this.dynamicVisible(elementItem.rules.dynamicVisibleValue)
                                })
                            })
                        }
                        newItem.chidrenDesc.push(chidrenDesc)
                        newItem.value.push(element)
                    })
                } else {
                    newItem.value = item.options.defaultValue
                    if (Array.isArray(newItem.value)) {
                        newItem.desc = []
                        newItem.value.forEach(id => {
                            newItem.desc.push(this.getValueText(id, item.options.defaultData))
                        })
                    } else {
                        newItem.desc = {
                            value: this.getValueText(item.options.defaultValue, item.options.defaultData),
                            label: item.options.label,
                            isShow: this.dynamicVisible(item.rules.dynamicVisibleValue)
                        }
                    }
                }
                newItem.isHidden = item.rules ? !this.dynamicVisible(item.rules.dynamicVisibleValue) : ['managementNodeInfo'].includes(item.options.attrKey)
                newItem.label = item.options.label
                newItem.attrKey = item.options.attrKey.split('-')[0]
                return newItem
            })
            return result
        },
        getNewFormData () {
            /* 组装数据结构修改后需要传递的数据 */
            const treeData = this.getTreeData()
            const result = this.formatNewData(treeData)
            return result
        },
        validate () {
            return {
                valid: this.$refs.configForm.validate(),
                data: this.getFormData(), // 兼容以前产品的数据结构
                configList: this.templateType === 'HPC-DRP' ? this.getNewFormData() : this.configForm.dataList
            }
        },
        oncheckItem (item, index) {
            // 为集群套餐填值
            this.$set(this.configForm.dataList[index].options, 'defaultValue', item)
            // 为文件系统table填值
            const storageInfoData = JSON.parse(item.storageInfo || '[]')
            this.storageInfoData = storageInfoData
            this.configForm.dataList.forEach(item => {
                if (item.type === 'storageInfoTable') {
                    this.$set(item.options, 'defaultValue', storageInfoData)
                }
            })
            this.inquiry(true)
            try {
                // 集群套餐
                this.$refs.configForm.fields[1].validateState = ''
                this.$refs.configForm.fields[1].validateMessage = ''
                // 文件系统
                this.$refs.configForm.fields[2].validateState = ''
                this.$refs.configForm.fields[2].validateMessage = ''
            } catch (e) {
                // --
            }
        }
    },
    watch: {
        panelDataList () {
            if (this.type === 'list') {
                this.openModal()
            }
        }
    }
}
</script>
<style lang="less">
.innerService {
    .ivu-form-item-label {
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
    }
    .norequired-mark {
        .ivu-form-item-label {
            padding-left: 12px !important;
        }
    }
    .strong {
        .ivu-form-item-label {
            font-weight: 700;
        }
    }
    .instruction {
        padding-top: 8px;
        color: #999999;
        line-height: 20px;
    }
}
</style>
<style lang="less" scope>
.obs {
    margin-top: -10px;
}
.group-title {
    font-size: 14px;
    font-weight: 700;
}
.divider {
    position: relative;
    width: 100%;
    border-bottom: 1px solid #e9e9e9;
    margin-bottom: 20px;
    span {
        position: absolute;
        left: 5%;
        top: 60%;
        padding: 0 10px;
        background-color: #fff;
    }
}
.innerService {
    margin-top: 10px !important;
    height: 100%;
    padding: 15px 40px;

    /deep/ .ivu-form-item-content {
        display: flex;
        align-items: center;
    }
    .calculation-item {
        display: inline-block;
        margin-right: 10px;
        border: 1px solid #e9e9e9;
        cursor: pointer;
        padding: 10px 16px;
        margin-bottom: 10px;
        line-height: 20px;
        input {
            display: none;
        }
        &:hover {
            color: #1f68b3 !important;
        }
        &.active {
            color: #fff;
            background-color: #1f68b3 !important;
            &:hover {
                color: #fff !important;
            }
        }
        &.active:hover {
            color: #fff !important;
        }
    }
    .refresh-icon {
        color: #007aff;
        cursor: pointer;
    }
}
</style>
